import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ImportFileModal from 'Common/Components/ImportFileModal';
import {
  selectCurrentUploadError, selectCurrentUploadPercent, selectCurrentUploadState,
  selectErrorFilesList, selectFileIndex, selectFiles,
  selectShowImport, selectUploadState
} from 'store/Credentials/selectors';
import {
  resetFileUploadState, setFileIndex, setFilesCount,
  setUploadState, showImportModal, uploadFile
} from 'store/Credentials/actions';
import { FormattedMessage } from 'react-intl';
import Wrapper from './styled';

const ImportCredentialModal = ({ isVulnDetail }) => {
  const dispatch = useDispatch();
  const showImport = useSelector(selectShowImport);
  const files = useSelector(selectFiles);
  const uploadState = useSelector(selectUploadState);
  const fileIndex = useSelector(selectFileIndex);
  const errorFilesList = useSelector(selectErrorFilesList);
  const currentUploadState = useSelector(selectCurrentUploadState);
  const currentUploadPercent = useSelector(selectCurrentUploadPercent);
  const currentUploadError = useSelector(selectCurrentUploadError);

  return (
    <Wrapper>
      <ImportFileModal
        show={ showImport }
        transactional
        handleClose={ () => dispatch(showImportModal(false)) }
        title={ <FormattedMessage id="credentials.import.title" /> }
        errorFilesList={ errorFilesList }
        uploadFile={ (files) => dispatch(uploadFile(files, isVulnDetail)) }
        setFileIndex={ (index) => dispatch(setFileIndex(index)) }
        setUploadState={ (state) => dispatch(setUploadState(state)) }
        setFilesCount={ (files) => dispatch(setFilesCount(files)) }
        resetFileUploadState={ () => dispatch(resetFileUploadState()) }
        files={ files }
        uploadState={ uploadState }
        fileIndex={ fileIndex }
        currentUploadState={ currentUploadState }
        currentUploadPercent={ currentUploadPercent }
        currentUploadError={ currentUploadError }
        docLink="https://docs.faradaysec.com/Credentials/"
        labelUpload="Import"
      />
    </Wrapper>
  );
};

export default ImportCredentialModal;
